import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import router from '../router'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: ['en', 'es']
})

const loadedModules = []

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

function loadModuleAsync (module, lang) {
  // If the module was already loaded
  if (loadedModules.includes(`${module}/${lang}`)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the module hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/locals/${module}/${lang}.json`).then(
    messages => {
      let i18nMessages = i18n.messages || {}
      i18nMessages[lang] = i18nMessages[lang] || {}
      i18nMessages[lang][module] = i18nMessages[lang][module] || {}
      i18nMessages[lang][module] = messages
      i18n.setLocaleMessage(lang, i18nMessages[lang])
      loadedModules.push(lang)
      return setI18nLanguage(lang)
    }
  ).catch(() => {
    return setI18nLanguage(lang)
  })
}

router.beforeEach((to, from, next) => {
  const module = to.path.substr(1).split('/')[0] || 'home'
  let userLang = navigator.language.split('-')[0]
  userLang = /(ca|en|es|fr|it)/gi.test(userLang) ? userLang : 'es'
  loadModuleAsync(module, userLang).then(() => next())
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js